const initialState = () => ({
  isOpened: false,
  onSuccessCallback: null,
  data: null
});

const ACTION_KEY = 'PAD_MODELS_INFORMATION_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { data, onSuccessCallback } = action.payload;

      return {
        ...state,
        isOpened: true,
        data,
        onSuccessCallback
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
